/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import PremiumModal from './../components/PremiumModal';
import SuccessRequestPremium from '../components/SuccessRequestPremium';
import Logo from './../assets/images/logo_ibid.png';
import User from './../assets/images/user.jpg';
import $ from 'jquery';
import ProfileModal from './ProfileModal';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clickUpgradePremium, viewPrivacyPolicy, viewProfileMenu } from '../services/amplitude';
import amplitude from 'amplitude-js';
import { removeLocalstorageLogout } from '../helper';
import { googleLogout } from '@react-oauth/google';

const TopNav = ({ pageChannel }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onLogout = () => {
    if (localStorage.getItem('login_with') === 'google') {
      googleLogout()
    }

    removeLocalstorageLogout();
    localStorage.clear()

    localStorage.removeItem('user');

    dispatch({
      type: 'LOGOUT',
    });

    amplitude.getInstance().clearUserProperties();

    if (history.location.pathname !== '/') {
      history.replace({ pathname: '/', state: { pageChannel } });
    } else if (history.location.pathname === '/') {
      history.go(0);
    }
  };

  useEffect(() => {
    dispatch({
      type: 'SET_CURRENT_PAGE',
      payload: pageChannel,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageChannel, localStorage.getItem('status')]);


  const userProfile = useSelector((state) => state.user.user_profile);
  const usernameLogic = (profile) => profile.users.first_name !== profile.users.last_name ? `${profile.users.first_name} ${profile.users.last_name}` : profile.users.first_name

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white">
      <ProfileModal />

      <a className="navbar-brand">
        <img
          style={{
            marginLeft: 30,
            width: 70,
            marginTop: -10,
            height: 60,
            cursor: 'pointer',
          }}
          onClick={() =>
            history.push({
              pathname: '/',
              state: {
                pageChannel: pageChannel,
              },
            })
          }
          src={Logo}
          alt="logo"
        />
      </a>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav mr-auto ml-5">
          <li className="nav-item active">
            <h5
              style={{
                marginLeft: 70,
                fontWeight: 'bold',
              }}
            >
              Market Auction Price
            </h5>
          </li>
        </ul>
        {!userProfile ? (
          <form className="form-inline my-2 my-lg-0">
            <button
              onClick={() => {
                history.push('/login', {
                  pageChannel,
                });
              }}
              className="my-2 my-sm-0 mr-3"
              type="submit"
              style={{
                width: 100,
                border: 0,
                color: '#82be2a',
                background: 'white',
              }}
            >
              Masuk
            </button>
            <button
              onClick={() => history.push('/register', { pageChannel })}
              className="btn-overview-green-solid-hovered my-2 my-sm-0 mr-3"
              type="submit"
              style={{ width: 100 }}
            >
              Daftar
            </button>
          </form>
        ) : (
          <div className="btn-group mr-2">
            <PremiumModal />
            <SuccessRequestPremium pageChannel={pageChannel} />
            <button
              style={{ border: 0, backgroundColor: '#ffffff' }}
              className="text-black"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div>
                <label className="mr-4 mt-1">{usernameLogic(userProfile)}</label>
                <img src={User} width={30} height={30} alt="user" />
              </div>
            </button>
            <div className="dropdown-menu dropdown-menu-right" style={{ width: 300 }}>
              <div className="px-4 pt-2">
                <b>{usernameLogic(userProfile)}</b>
                <br />
                <label>{userProfile.users.Email}</label>
              </div>
              <hr />
              {localStorage.getItem('status') != 3 && (
                <button
                  data-toggle="modal"
                  data-target="#modal-premium"
                  className="dropdown-item"
                  type="button"
                  style={{ color: '#A3CF62', fontWeight: 700 }}
                  onClick={() => clickUpgradePremium(pageChannel)}
                >
                  Tingkatkan Akun ke Premium
                </button>
              )}
              <button
                onClick={() => {
                  $('#modal-profile').modal('toggle');
                  viewProfileMenu();
                }}
                className="dropdown-item"
                type="button"
              >
                Profile
              </button>
              <button className="dropdown-item" type="button" onClick={() => viewPrivacyPolicy()}>
                <Link to="/syarat-ketentuan" style={{ color: 'inherit', textDecoration: 'none' }}>
                  Syarat & Ketentuan
                </Link>
              </button>
              <hr />
              <button className="dropdown-item text-danger" onClick={onLogout} type="button">
                Keluar
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default TopNav;
